import {
 onMounted, onUnmounted, ref, Ref,
} from '@vue/composition-api';

export function useIconSizeObserver(iconElement: Ref<HTMLElement | undefined>): Ref<number> {
  const iconSize = ref<number>(0);
  const observer = new ResizeObserver(entries => {
    entries.forEach((entry) => {
      if (entry.target) {
        updateHeight(entry.target);
      }
    });
  });

  onMounted(() => {
    if (iconElement.value) {
      updateHeight(iconElement.value);
      observer.observe(iconElement.value);
    }
  });

  onUnmounted(() => {
    if (iconElement.value) {
      observer.unobserve(iconElement.value);
    }

    observer.disconnect();
  });

  return iconSize;

  function updateHeight(element: Element) {
    const rects = element.getBoundingClientRect();

    if (rects) {
      iconSize.value = rects.width;
    }
  }
}
